import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faUpload, faTimes } from '@fortawesome/free-solid-svg-icons';

const ShareExperienceForm = ({ formData, errors, handleChange, handleImageChange, handleRemoveImage }) => {
  const maxImages = 10;
  const canAddMore = formData.images.length < maxImages;

  return (
    <div className="boat-lead-form__form">
      <div className="form-group-row">
        <div className="form-group">
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="Full Name*"
            className={errors.fullName ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.fullName}</p>
          </div>
        </div>

        <div className="form-group">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email*"
            className={errors.email ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.email}</p>
          </div>
        </div>
      </div>

      <div className="form-group">
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Share your boating experience, tips, or memorable moments...*"
          className={errors.message ? 'error' : ''}
          rows="4"
        />
        <div className="error-message-container">
          <p className="error-message">{errors.message}</p>
        </div>
      </div>

      <div className="form-group">
        <div className="image-upload-container">
          {canAddMore && (
            <label htmlFor="image-upload" className="image-upload-label">
              <FontAwesomeIcon icon={faUpload} />
              <span>Add Photos (Optional) - {formData.images.length}/{maxImages}</span>
              <input
                type="file"
                id="image-upload"
                name="images"
                onChange={handleImageChange}
                multiple
                accept="image/*"
                className="image-upload-input"
              />
            </label>
          )}
          
          {!canAddMore && (
            <div className="image-upload-limit-reached">
              <FontAwesomeIcon icon={faImage} />
              <span>Maximum {maxImages} images reached</span>
            </div>
          )}

          {formData.images.length > 0 && (
            <div className="uploaded-images-preview">
              <p className="uploaded-count">
                {formData.images.length} image{formData.images.length !== 1 ? 's' : ''} selected
              </p>
              <div className="image-preview-grid">
                {formData.images.map((file, index) => (
                  <div key={`${file.name}-${index}`} className="image-preview-item">
                    <img
                      src={URL.createObjectURL(file)}
                      alt={`Preview ${index + 1}`}
                      className="preview-image"
                    />
                    <button
                      type="button"
                      className="remove-image-btn"
                      onClick={() => handleRemoveImage(index)}
                      title="Remove image"
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="error-message-container">
          <p className="error-message">{errors.images}</p>
        </div>
      </div>
    </div>
  );
};

export default ShareExperienceForm;
